"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = { class: "card-row" };
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_CardRowComponent = (0, vue_1.resolveComponent)("CardRowComponent");
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, [
        ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.rowData, (componentData, i) => {
            return ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_CardRowComponent, {
                componentData: componentData,
                key: i
            }, null, 8, ["componentData"]));
        }), 128))
    ]));
}
